import { useState } from 'react'
import './PresetButtons.css';


function PresetButtons({presetButtons, buttonOnClick}) {

  if(!presetButtons || presetButtons.length === 0) {
    return ( <div className="preset-buttons empty"></div> );
  }

  return (
    <div className="preset-buttons-section">
      <ul className="preset-buttons">
        {presetButtons?.map((presetButton) => {
          return (
            <li className="preset-buttons-item" key={presetButton.button_text}>
              <button onClick={() => buttonOnClick(presetButton.button_prompt)} className="preset-button">{presetButton.button_text}</button>
            </li>
          )
        }
        )}
      </ul>
    </div>
  );
}

export default PresetButtons;
